module.exports = __webpack_public_path__ + "static/media/Jason Blake Headshot.46c10546.jpeg";